/**
 *	shops-by-city-or-district.conf.js
 */
 
import angular from 'angular';

import ShopsByCityOrDistrictCtrl from './shops-by-city-or-district.ctrl.js';
import shopsByCityOrDistrictTpl from './shops-by-city-or-district.tpl.html!text';

var shopsByCityOrDistrict = function($stateProvider) {
   
    $stateProvider.state('shops-by-district', {
        url: '/judet/:district',
        controller: ShopsByCityOrDistrictCtrl,
        controllerAs: 'ctrl',
        template: shopsByCityOrDistrictTpl
    });
    
    $stateProvider.state('shops-by-city', {
        url: '/judet/:district/oras/:city',
        controller: ShopsByCityOrDistrictCtrl,
        controllerAs: 'ctrl',
        template: shopsByCityOrDistrictTpl
    });
};

shopsByCityOrDistrict.$inject = ['$stateProvider'];

export default angular.module('shopsByCityOrDistrict', [])
    .config(shopsByCityOrDistrict)
    .name;